import PropTypes from 'prop-types';

const meShape = PropTypes.shape({
  email: PropTypes.arrayOf(PropTypes.string),
  familyName: PropTypes.string,
  givenName: PropTypes.string,
  roles: PropTypes.arrayOf(PropTypes.string),
});

export default meShape;
